// Central config (can even be moved to separate file later)
const SHIPPING_CONFIG = {
  leadTimeByDayType: {
    weekday: {
      1: 1,
      3: 3,
      7: 7,
      30: 30
    },
    weekend: {
      1: 3,
      3: 6,
      7: 10,
      30: 33
    }
  },

  shippingMethods: {
    'Economy': { minDays: 10, maxDays: 12, label: 'Estimated Arrival' },
    'Free Economy': { minDays: 10, maxDays: 12, label: 'Estimated Arrival' },
    'Standard': { minDays: 3, maxDays: 8, label: 'Estimated Arrival' },
    'UPS 2nd Day Air': { minDays: 2, maxDays: 2, label: 'Estimated Arrival' },
    'UPS Next Day Air': { minDays: 1, maxDays: 1, label: 'Estimated Arrival' },
    'Instore Pickup (Richmond, Virginia)': { minDays: 1, maxDays: 1, label: 'Ready for Pickup' }
  }
};

window.estimateShippingArrival = (selectedShippingMethod = 'none') => {
  const today = new Date();

  // Helper: format date nicely
  const formatDate = (date) =>
    date.toLocaleDateString('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric'
    });

  // Helper: safely add days
  const addDays = (baseDate, daysToAdd) => {
    const resultDate = new Date(baseDate);
    resultDate.setDate(resultDate.getDate() + daysToAdd);
    return resultDate;
  };

  // Determine weekday vs weekend logic
  const dayOfWeek = today.getDay(); // 0–6
  const isBusinessDay = dayOfWeek >= 1 && dayOfWeek <= 4;
  const dayType = isBusinessDay ? 'weekday' : 'weekend';

  // Normalize lead time
  const selectedLeadTime = Number(window.leadTime);

  // Get shipping preparation delay
  const shippingPreparationDays =
    SHIPPING_CONFIG.leadTimeByDayType[dayType]?.[selectedLeadTime] ?? 0;

  // Get shipping method delivery range
  const shippingMethodDetails =
    SHIPPING_CONFIG.shippingMethods[selectedShippingMethod] ?? {
      minDays: 0,
      maxDays: 0,
      label: 'Estimated Arrival'
    };

  const {
    minDays: deliveryStartOffset,
    maxDays: deliveryEndOffset,
    label: deliveryLabel
  } = shippingMethodDetails;

  // Calculate key dates
  const estimatedShipDate = addDays(today, shippingPreparationDays);
  const estimatedArrivalStart = addDays(today, shippingPreparationDays + deliveryStartOffset);
  const estimatedArrivalEnd = addDays(today, shippingPreparationDays + deliveryEndOffset);

  // Format outputs
  const shipDateText = formatDate(estimatedShipDate);

  let arrivalText = `<em class="estimated-arrival-dt">${deliveryLabel}: <span>${formatDate(estimatedArrivalStart)}`;

  if (deliveryStartOffset !== deliveryEndOffset) {
    arrivalText += ` - ${formatDate(estimatedArrivalEnd)}`;
  }

  arrivalText += '</span></em>';

  // Handle "no shipping selected" case
  if (selectedShippingMethod === 'none') {
    const shipDateElement = document.getElementById('productFormShipDate');
    if (shipDateElement) {
      shipDateElement.innerHTML = shipDateText;
    }
    return shipDateText;
  }

  // Return arrival range if valid
  if (deliveryStartOffset !== 0 || deliveryEndOffset !== 0) {
    return arrivalText;
  }

  return '';
};

// Initial call
window.estimateShippingArrival('none');